import React, { useState } from "react";
import api from "../api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [pwd, setPwd] = useState("");

  const sendOtp = async () => {
    await api.post("/auth/forgot-password", { email });
    setOtpSent(true);
  };

  const resetPwd = async () => {
    await api.post("/auth/reset-password", { email, otp, password: pwd });
    alert("Password reset successful");
  };

  return (
    <div style={page}>
      <div style={overlay}>
        <div style={card}>
          <img src="/logo.png" alt="EduAt10" style={logo} />
          <h2>Forgot Password</h2>

          <input placeholder="Email" onChange={e => setEmail(e.target.value)} />

          {!otpSent ? (
            <button onClick={sendOtp} style={btn}>Send OTP</button>
          ) : (
            <>
              <input placeholder="OTP" onChange={e => setOtp(e.target.value)} />
              <input placeholder="New Password" type="password"
                onChange={e => setPwd(e.target.value)} />
              <button onClick={resetPwd} style={btn}>Reset Password</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

const page = { minHeight: "100vh", backgroundImage: "url('/eduat10-bg.png')" };
const overlay = { minHeight: "100vh", background: "rgba(0,0,0,0.3)", padding: 20 };
const card = { maxWidth: 420, margin: "auto", background: "#fff", padding: 30, borderRadius: 16 };
const logo = { width: 120, marginBottom: 10 };
const btn = { padding: 12, background: "#2563eb", color: "#fff", border: "none", borderRadius: 8 };
